import { Icon } from '@wix/answers-ui-libby';
import * as React from 'react';
export var checkboxIconSvgData = "\n\t<svg width=\"13\" height=\"10\" viewBox=\"0 0 13 10\">\n\t\t<path d=\"M3.788 9.073l.71.72.712-.72 7.587-7.666L11.375 0l-6.86 6.962-3.092-3.128L0 5.24l3.788 3.833z\"></path>\n\t</svg>\n";
export var CheckboxIcon = function () { return (React.createElement("span", { className: 'check-icon' },
    React.createElement(Icon, { icon: checkboxIconSvgData }))); };
//# sourceMappingURL=checkbox-icon.js.map